import { render, staticRenderFns } from "./uploadChange.vue?vue&type=template&id=b4bb34d0&scoped=true"
import script from "./uploadChange.vue?vue&type=script&lang=js"
export * from "./uploadChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb34d0",
  null
  
)

export default component.exports